import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useTriggerEventMutations } from '../../../hooks/useNomenclatures';

const TriggerEventList = ({ items, onUpdate }) => {
  const mutations = useTriggerEventMutations();

  const fields = [
    { 
      name: 'category', 
      label: 'Category', 
      type: 'select',
      options: ['Patient', 'Device', 'Procedure', 'System']
    },
    { 
      name: 'priority', 
      label: 'Priority', 
      type: 'select',
      options: ['High', 'Medium', 'Low']
    }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="trigger-events"
      title="Trigger Events"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default TriggerEventList;

